import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { isShipFromExternal } from '../../store/csw/csw.fulfillment-plan-to-csw';
import * as Actions from '../../store/csw/csw.actions';
import { EXTERNAL, SHIPMENT } from '../../constants/fulfillment-types';

export const useShipFromState = (fulfillmentPlanId, computedShipFromId, onConfigurationChange) => {
  const externalShipFromId = isShipFromExternal(computedShipFromId) ? computedShipFromId : null;

  const fulfillmentType = isShipFromExternal(computedShipFromId) ? EXTERNAL : SHIPMENT;

  const dispatch = useDispatch();
  const onShipFromChange = useCallback(
    (newShipFromId, options) => {
      const { skipSave } = options || {};
      const wasExternal = isShipFromExternal(computedShipFromId);
      const isExternal = isShipFromExternal(newShipFromId);

      const shouldChangeMode = (isExternal && !wasExternal) || (!isExternal && wasExternal);
      if (shouldChangeMode) {
        if (!isExternal) {
          dispatch(Actions.exitExternalFulfillmentMode(fulfillmentPlanId));
        } else {
          dispatch(Actions.enterExternalFulfillmentMode(fulfillmentPlanId));
        }
      }
      dispatch(Actions.startUpdateAvailableShippingServices(fulfillmentPlanId, newShipFromId));

      if (skipSave) {
        return;
      }
      dispatch(Actions.updateShipmentConfiguration(fulfillmentPlanId, { shipFromId: newShipFromId }, isExternal));

      const isEnteringExternalFulfillment = !wasExternal && isExternal;
      onConfigurationChange({ shipFromId: newShipFromId }, { isEnteringExternalFulfillment, shouldUpdateNeedsCustoms: true });
    },
    [dispatch, fulfillmentPlanId, onConfigurationChange, computedShipFromId],
  );

  return {
    externalShipFromId,
    fulfillmentType,
    onShipFromChange,
  };
};
